import {User} from '@/models/user_schema';

export type RepState = {
  rep: User[],
  selected: User | null
};

export type RepContext = {
  state: RepState;
  dispatch: (action: RepActions, payload?: any) => any;
  commit: (mutation: RepMutations, payload: any) => any;
};

export enum RepMutations {
  SetRep = "setRep",
  SetSelected = "setSelected"
}

export enum RepActions {
  AddAllReps = "addAllReps",
  ClearReps = "clearReps",
  EditRep = "editRep",
  AddRep = "addRep",
  DeleteRep = "deleteRep",
  FetchSingleRep ='fetchSingleRep',
  SetSelectedRep = 'setSelectedRep'
}

export enum RepGetters {
  GetAllReps = "getAllReps",
  GetSelected = "getSelected"
}
